import React, { useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "routes.js";
import { getTokenBPO, isTokenExpired } from "util/security";

const AdminLayout = (props) => {
  const mainContent = React.useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const bpoToken = getTokenBPO();
    if (!bpoToken && !isTokenExpired(bpoToken)) {
      navigate("/login", { replace: true });
    }

    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [navigate]);

  return (
    <>
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/admin/index",
          imgSrc: require("../assets/img/brand/logo-prosper.png"),
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <Outlet />
      </div>
    </>
  );
};

export default AdminLayout;
